"use strict";
import $ from "jquery";
import Inputmask from "inputmask";
import validate from "jquery-validation";

export default class CompaniesQuotation {
  constructor() {
    this.name = "companiesQuotation";

    $("#container-quotation-results").hide();
    $("#container-quotation-submitted").hide();

    var alquiler = $("#alquiler");
    var expensas = $("#expensas");
    var ajuste = $("#ajuste");
    var plazo = $("#plazo");
    var nombre = $("#nombre");
    var telefono = $("#telefono");
    var mail = $("#mail");

    var numericMask = new Inputmask("numeric", {
      alias: "numeric",
      groupSeparator: ".",
      autoGroup: true,
      autoUnmask: true,
      digits: 0,
      rightAlign: false,
      allowMinus: false,
      prefix: "$ ",
      placeholder: ""
    });
    numericMask.mask(alquiler);
    numericMask.mask(expensas);

    var percentajeMask = new Inputmask("decimal", {
      groupSeparator: ".",
      radixPoint: ",",
      autoGroup: true,
      autoUnmask: true,
      digits: 1,
      rightAlign: false,
      allowMinus: false,
      max: 100,
      suffix: " %",
      placeholder: ""
    });
    percentajeMask.mask(ajuste);

    var phoneMask = new Inputmask("99 9999-9999", { placeholder: "" });
    phoneMask.mask(telefono);

    var mailMask = new Inputmask("email", { placeholder: "" });
    mailMask.mask(mail);

    $("#companies-quotation-form").validate({
      rules: {
        alquiler: {
          required: true
        },
        expensas: {
          required: true
        },
        plazo: {
          required: true
        },
        ajuste: {
          required: true
        },
        errorPlacement: function(error, element) {
          return true;
        }
      }
    });

    $("#companies-contact-form").validate({
      rules: {
        nombre: {
          required: true
        },
        telefono: {
          required: true,
          minlength: 8
        },
        mail: {
          required: true,
          email: true
        },
        errorPlacement: function(error, element) {
          return true;
        }
      }
    });

    $("#companies-contact-form").submit(function(event) {
      event.preventDefault();

      console.log(nombre.val());
      console.log(telefono.val());
      console.log(mail.val());

      if ($("#companies-contact-form").valid()) {
        $("#container-quotation-results").fadeOut(500, function() {
          $("#container-quotation-submitted").fadeIn(500);
        });
      }
    });

    $("#companies-quotation-form").submit(function(event) {
      event.preventDefault();

      console.log(alquiler.val());
      console.log(expensas.val());
      console.log(plazo.val());
      console.log(ajuste.val());

      if ($("#companies-quotation-form").valid()) {
        $("#container-quotation-form").fadeOut(500, function() {
          $("#container-quotation-results").fadeIn(500);
        });
      }

      fetch("http://localhost:8080/api/cotizar/empresas", {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          cotizacion: {
            alquiler: parseInt(
              $("#alquiler")
                .val()
                .replace(/\D/g, ""),
              10
            ),
            expensas: parseInt(
              $("#expensas")
                .val()
                .replace(/\D/g, ""),
              10
            ),
            plazo: parseInt(
              $("#plazo")
                .val()
                .replace(/\D/g, ""),
              10
            ),
            ajuste: parseInt(
              $("#ajuste")
                .val()
                .replace(/\D/g, ""),
              10
            )
          }
        })
      })
        .then(function() {})
        .catch(function() {
          // This is where you run code if the server returns any errors
        });
    });
  }
}
